import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { ReactComponent as ThreeDot } from "../../../../../assets/MainPage/viewBlocks/ThreeDotIon.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/MainPage/viewBlocks/editIcon.svg";
import { ReactComponent as EditIconDark } from "../../../../../assets/MainPage/viewBlocks/editIcon-dark.svg";

import { ReactComponent as CheckedIcon } from "../../../../../assets/payment/tick-square.svg";
import { ReactComponent as UnCheckedIcon } from "../../../../../assets/payment/tick-unCheck-square.svg";

import { Link } from "react-router-dom";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// redux
import { useDispatch, useSelector } from "react-redux";
import { creatingChangeBLock } from "../../../../../redux/slices/block/changeStatusBlockSlice";
import {
  gettingLinkList,
  resetLinkList,
} from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";

const LinkViewBlockCard = ({
  item,
  iconBgClasses,
  iconClasses,
  checkBoxChangeHandler,
  ids,
}) => {
  const { darkMode } = useSelector((state) => state.theme);
  const ImageUrl = process.env.REACT_APP_API_URL;
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const [WinW, setWinW] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWinW(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const SortableItemContext = createContext({
    attributes: {},
    listeners: undefined,
    ref() {},
  });
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({
    id: item?._id,
  });
  const context = useMemo(
    () => ({
      attributes,
      listeners,
      ref: setActivatorNodeRef,
    }),
    [attributes, listeners, setActivatorNodeRef]
  );

  const style = {
    opacity: isDragging ? 0.4 : undefined,
    transform: CSS.Translate.toString(transform),
    transition,
  };

  const { ref } = useContext(SortableItemContext);

  const [state, setState] = useState(null);
  const [URLvalue, setURLvalue] = useState(null);
  useEffect(() => {
    setState(item);
    setURLvalue(JSON.parse(item?.coloum_value)?.coloum_value);
  }, [item]);

  const changeCardStatus = async (e) => {
    const { checked } = e.target;
    setState({ ...state, status: checked });
    // e.prevent.default()
    const data = {
      status: checked,
      optionid: item?._id,
    };
    await dispatch(creatingChangeBLock(data)).then(() => {});

    await fetchingLinkList();
    // closeBlockSubModal('BioSecSoundCloudModalState')
  };

  const fetchingLinkList = async () => {
    // const linkId = getLinktate?.getBioLink?.response?.[0]?._id;
    const linkId = localStorage.getItem("linkId");
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.userid;
    const usertoken = user.token;
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    await dispatch(gettingLinkList(linkListData));
    dispatch(resetLinkList());
  };

  useEffect(() => {
    if (ids && item && item._id) {
      // Add null checks for ids and item
      if (ids.includes(item._id)) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    }
  }, [ids, item]);

  return (
    <SortableItemContext.Provider value={context}>
      <li
        ref={setNodeRef}
        style={style}
        className="flex items-center gap-[4px] md:gap-2.5"
      >
        <div className="hover:bg-slate-200 rounded-full p-1">
          <ThreeDot
            {...attributes}
            {...listeners}
            ref={ref}
            className="cursor-grab"
          />
        </div>
        <div
          className={`w-full rounded-lg md:rounded-[10px] ${
            darkMode ? "" : "shadow-shadow_2 md:shadow-shadow"
          } bg-white dark:bg-dark-secondary p-3 md:py-3 md:px-[15px] flex items-center gap-[13px] md:gap-3`}
        >
          <div>
            <div onClick={() => checkBoxChangeHandler(item?._id)}>
              {checked ? (
                <CheckedIcon className="w-[18px] h-[18px] xl:w-[24px] xl:h-[24px] cursor-pointer" />
              ) : (
                <UnCheckedIcon className="w-[18px] h-[18px] xl:w-[24px] xl:h-[24px] cursor-pointer" />
              )}
            </div>
          </div>
          {item?.linkIcon && (
            <div>
              <Link to={`/dashboard/component/editLink/${item?._id}`}>
                <img
                  className={`${iconClasses} max-h-[36px] min-h-[36px] h-[36px] max-w-[36px] min-w-[36px] w-[36px] object-cover rounded-md p-[1.5px]`}
                  src={` ${
                    item?.linkIcon
                      ? ImageUrl + "/profile/" + item?.linkIcon
                      : ""
                  }`}
                  alt="..."
                />
              </Link>
            </div>
          )}
          <div className="w-full flex justify-between">
            <Link to={`/dashboard/component/editLink/${item?._id}`}>
              <div className=" ">
                <div className=" text-small2_b text-body_copy1_color dark:text-color_v1_dark capitalize">
                  {WinW < 470
                    ? item?.coloum_type?.length > 16
                      ? item?.coloum_type?.slice(0, 16) + "..."
                      : item?.coloum_type
                    : WinW < 768
                    ? item?.coloum_type?.length > 28
                      ? item?.coloum_type?.slice(0, 28) + "..."
                      : item?.coloum_type
                    : WinW < 990
                    ? item?.coloum_type?.length > 11
                      ? item?.coloum_type?.slice(0, 11) + "..."
                      : item?.coloum_type
                    : WinW < 1400
                    ? item?.coloum_type?.length > 22
                      ? item?.coloum_type?.slice(0, 22) + "..."
                      : item?.coloum_type
                    : item?.coloum_type?.length > 38
                    ? item?.coloum_type?.slice(0, 38) + "..."
                    : item?.coloum_type}
                </div>

                <div className="text-small3 text-font_light_color dark:text-color_v2_dark">
                  {WinW < 470
                    ? URLvalue?.length > 22
                      ? URLvalue?.slice(0, 22) + "..."
                      : URLvalue
                    : WinW < 768
                    ? URLvalue?.length > 41
                      ? URLvalue?.slice(0, 41) + "..."
                      : URLvalue
                    : WinW < 990
                    ? URLvalue?.length > 14
                      ? URLvalue?.slice(0, 14) + "..."
                      : URLvalue
                    : WinW < 1400
                    ? URLvalue?.length > 32
                      ? URLvalue?.slice(0, 32) + "..."
                      : URLvalue
                    : URLvalue?.length > 51
                    ? URLvalue?.slice(0, 51) + "..."
                    : URLvalue}
                </div>
              </div>
            </Link>
            <div className="flex gap-2 md:gap-[15px] items-center">
              <Link to={`/dashboard/component/editLink/${item?._id}`}>
                {darkMode ? <EditIconDark /> : <EditIcon />}
              </Link>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={state?.status}
                  onChange={(e) => changeCardStatus(e)}
                  className="sr-only peer"
                />
                <div className="w-[29px] h-[15px] bg-gray-200 dark:bg-[#404040] rounded-full peer  peer-checked:after:translate-x-[13.5px] peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[11px] after:w-[11px] after:transition-all peer-checked:bg-green-600"></div>
              </label>
            </div>
          </div>
        </div>
      </li>
    </SortableItemContext.Provider>
  );
};

export default LinkViewBlockCard;
